import React, { useState, useEffect, useMemo } from 'react'
// @ts-ignore: cronofy-elements doesn't support ts
import * as CronofyElements from 'cronofy-elements'
import moment from 'moment'

import env from 'helpers/env'

import { CronofyCalendar } from 'generated/types'

const CronofyAvailabilityViewer: React.FC<CronofyAvailabilityViewerProps> = (props) => {
  const {
    calendar,
    onSlotSelected,
  } = props
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  const [element, setElement] = useState<any>()

  const options = useMemo(() => ({
    element_token: calendar.elementToken,
    target_id: 'cronofy-availability-viewer',
    data_center: env.CRONOFY_DATA_CENTER,
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    callback: (event: any) => {
      if (event.notification.type === 'slot_selected' && onSlotSelected) {
        onSlotSelected(event.notification.slot.start, event.notification.slot.end)
      }
    },
    availability_query: {
      participants: [{
        required: 'all',
        members: [{
          sub: calendar.sub,
          calendar_ids: calendar.calendarId ? [calendar.calendarId] : undefined,
        }],
      }],
      required_duration: { minutes: 60 * 4 },
      query_periods: [{
        start: moment().add(1, 'hour').startOf('hour').toISOString(),
        end: moment().startOf('day').add(200, 'days').toISOString(),
      }],
    },
    config: {
      start_time: '08:00',
      end_time: '18:00',
      bounds_control: true,
    },
  }), [calendar, onSlotSelected])

  useEffect(() => {
    if (!element) {
      setElement(CronofyElements.AvailabilityViewer(options))
    }
  }, [])

  useEffect(() => {
    if (element) {
      element.update(options)
    }
  }, [options])

  return (
    <div id={options.target_id} />
  )
}

interface CronofyAvailabilityViewerProps {
  calendar: CronofyCalendar
  onSlotSelected?: (start: string, end: string) => void
}

export default CronofyAvailabilityViewer
